import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ru } from 'date-fns/locale';
import React, { useCallback, useRef, useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const CustomDatePicker = ({ label, prefix, ...restProps }) => {
  const datePickerRef = useRef(null);
  const [calendarOpen, setCalendarOpen] = useState(false);

  const openCalendar = useCallback(() => {
    console.log(calendarOpen);
    if (!calendarOpen) {
      setCalendarOpen(true);
      if (datePickerRef.current) {
        datePickerRef.current.setOpen(true);
      }
    }
  }, [calendarOpen]);

  const handleReset = (e) => {
    e.stopPropagation();
    if (restProps.selected) {
      restProps.onChange(null);
    }
  };

  return (
    <div onClick={openCalendar} className="custom-date-picker flex items-center bg-white w-full px-2 py-2 border border-gray-300 shadow-sm rounded-lg text-sm">
      {prefix && prefix}
      {label && <label>{label}</label>}

      <DatePicker
        dateFormat={'dd.MM.yyyy HH:mm'}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="Время"
        peekNextMonth
        ref={datePickerRef}
        showTimeOnly={false}
        locale={ru}
        onCalendarClose={() => setCalendarOpen(false)}
        className={'outline-none'}
        {...restProps}
      />
      <CloseOutlinedIcon sx={{ width: 16, height: 16 }} className={'cursor-pointer ml-auto text-gray-500'} onClick={handleReset} />
    </div>
  );
};

export default CustomDatePicker;
